module.exports = __webpack_public_path__ + "img/2300m.865f8750.png";